import { PaymentInboundRequestListPage } from "@/features/payment-inbound-request/pages/PaymentInboundRequestListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/payment-inbound-request/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["it.monitoring.payment_transaction"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: PaymentInboundRequestListPage,
});
